const siteUrl = process.env.REACT_APP_SITE_URL || "https://mydealcase.com";

export const siteConfig = {
  name: "MyDealCase",
  tagline: "Buy, Resell, Rent, Service & Donate",
  siteUrl,
  supportEmail: process.env.REACT_APP_SUPPORT_EMAIL || "support@mydealcase.com",
  supportPhone: process.env.REACT_APP_SUPPORT_PHONE || "+91-9596979571",
  companyName: "Innorent Tech Private Limited",
  address:
    "Shop No. 8041, Near Disposal Chowk, Jawahar Colony, Faridabad, Haryana, 121005",
  googlePlayUrl:
    process.env.REACT_APP_GOOGLE_PLAY_URL ||
    "https://play.google.com/store/apps/details?id=com.mydealcase.my_deal_case",
  appStoreUrl:
    process.env.REACT_APP_APP_STORE_URL ||
    "https://apps.apple.com/in/app/mydealcase/id6749686434",
  ogImage: `${siteUrl}/img/icons/logo512.png`,
  copyrightYear: new Date().getFullYear(),
};

export const getStoreUrl = (): string => {
  if (typeof window === "undefined") {
    return siteConfig.googlePlayUrl || siteConfig.appStoreUrl || "#download";
  }

  const ua = window.navigator.userAgent.toLowerCase();
  const isIOS = /iphone|ipad|ipod/.test(ua);
  const isAndroid = /android/.test(ua);

  if (isIOS && siteConfig.appStoreUrl) return siteConfig.appStoreUrl;
  if (isAndroid && siteConfig.googlePlayUrl) return siteConfig.googlePlayUrl;
  if (siteConfig.googlePlayUrl) return siteConfig.googlePlayUrl;
  if (siteConfig.appStoreUrl) return siteConfig.appStoreUrl;

  return "#download";
};

export const openAppDownload = () => {
  const url = getStoreUrl();
  if (url.startsWith("#")) {
    document.getElementById(url.slice(1))?.scrollIntoView({ behavior: "smooth" });
    return;
  }
  window.open(url, "_blank", "noopener,noreferrer");
};
